import { useLang } from "@/i18n/LanguageContext";
import { useSettings } from "@/lib/useSettings";
import SeoHead, { SITE_URL } from "@/components/SeoHead";
import { buildOrganizationSchema, buildPersonSchema } from "@/lib/schema";

const About = () => {
  const { t, lang } = useLang();
  const { settings } = useSettings();
  return (
    <div data-testid="about-page">
      <SeoHead
        lang={lang}
        path="/about"
        title={lang === "fr" ? "À propos de Dataleo" : "About Dataleo"}
        description={lang === "fr"
          ? "Dataleo aide les entreprises à construire, gouverner et industrialiser les outils IA de décision en Supply Chain et Operations. Fondé par Jean-François Nordmann."
          : "Dataleo helps companies build, govern and industrialize AI-built decision tools in Supply Chain and Operations. Founded by Jean-François Nordmann."}
        jsonLd={[
          buildOrganizationSchema({ baseUrl: SITE_URL, settings }),
          buildPersonSchema({ baseUrl: SITE_URL, settings }),
        ]}
      />
      <section className="bg-[#111827] text-white">
        <div className="dl-container py-20">
          <div className="dl-overline text-[#00A878]">About Dataleo</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3 leading-tight max-w-4xl">
            {t.about.title}
          </h1>
        </div>
        <div className="dl-rule" />
      </section>
      <section className="dl-container py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7 space-y-6 text-[16px] leading-[1.8] text-[#111827]">
          <p className="text-[19px] text-[#4B5563]">{t.about.lead}</p>
          <p>{t.about.p1}</p>
          <blockquote className="border-l-4 border-[#00A878] pl-6 py-2 italic text-[#111827] text-[22px] font-display leading-snug">
            "{t.about.pull}"
          </blockquote>
          <p>{t.about.p2}</p>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/3] border border-[#E5E7EB] overflow-hidden bg-[#F3F4F6]">
            <img
              src="https://customer-assets.emergentagent.com/job_ai-ops-signal/artifacts/1em9t85d_608B296F-3480-4D33-ADD9-6DAAB4593181.png"
              alt="Dataleo team — ecosystem of partners and contributors"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="mt-4 text-[12px] text-[#4B5563] font-mono-dl uppercase tracking-wider">
            Dataleo team · ecosystem of partners & contributors
          </div>
          <div className="mt-6 p-6 bg-[#F3F4F6] border border-[#E5E7EB]">
            <div className="dl-overline text-[#00A878]">Dataleo language</div>
            <ul className="mt-3 space-y-2 text-sm">
              {["AI-built tools", "Decision Apps", "Decision Architecture", "Supply Chain AI Build Office", "Governed middle layer", "Shadow IT exposure"].map((v) => (
                <li key={v} className="font-mono-dl">→ {v}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
